import React, { Component } from "react";
import { FormGroup, FormControl, FormLabel, Button } from "react-bootstrap";

import i18n from "i18next";
import PropTypes from "prop-types";

export default class ApplyAllScenesProvider extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);
    this.index = 0;
    /**
     * Component's initial state
     */
    this.state = {
      open: false,
    };
  }

  /**
   * Render React Component
   * @returns {XML}
   */
  render() {
    let bckg = this.props.formControlProps
      ? this.props.value !== undefined
        ? this.props.value
        : this.props.formControlProps.value
      : null;
    let isURI = /data\:/.test(bckg);
    let props = {
      ...this.props.formControlProps,
      placeholder: isURI ? "http://..." : "",
      value: isURI ? "" : bckg,
    };

    return (
      <FormGroup
        style={{
          display: this.props.hide ? "none" : "block",
          borderTop: "1px solid #e5e7eb",
          marginTop: "16px",
          paddingTop: "16px",
        }}
      >
        <Button
          className={"toolbarButton"}
          onClick={() => {
            this.setState({ open: !this.state.open });
            this.props.setUploadTemplateVisible();
          }}
        >
          {props.label}
        </Button>
        <div style={{ marginTop: "4px", fontSize: "9px", lineHeight: 1.4, color: "#6b7280" }}>
          {i18n.t("marks.applyAllScenesNote")}
        </div>
      </FormGroup>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.fileModalResult &&
      nextProps.fileModalResult &&
      nextProps.id === nextProps.fileModalResult.id &&
      nextProps.fileModalResult.value &&
      this.props.fileModalResult.value !== nextProps.fileModalResult.value
    ) {
    }
  }
}

ApplyAllScenesProvider.propTypes = {
  /**
   * Toolbar input inherited props
   */
  formControlProps: PropTypes.object,
  /**
   * Input Value
   */
  value: PropTypes.any,
  /**
   * Open File Modal
   */
  openModal: PropTypes.func,
  /**
   * Id of the box/page being edited
   */
  id: PropTypes.any,
  /**
   * Mime Type accepted
   */
  accept: PropTypes.string,
  /**
   * Button text
   */
  buttontext: PropTypes.string,
  /**
   * Last files uploaded to server or searched in modal
   */
  fileModalResult: PropTypes.object,
  /**
   * Toolbar change callback
   */
  onChange: PropTypes.func,
  /**
   * Hide external provider input type
   */
  hide: PropTypes.bool,
};
